<div class="editor-dialog">
    <div class="editor-content">
        <ng-container [ngSwitch]="mode()">
            <!-- Mode none -->
            <ng-container *ngSwitchCase="'none'">
                <ng-container *ngIf="currentModel()?.mapImageSrc?.length > 0; else noImage">
                    <div id="calibration-map-container" #calibrationMapContainer class="map-container">
                        <img [src]="currentModel()?.mapImageSrc" class="calibration-image" />
                    </div>
                </ng-container>

                <ng-template #noImage>
                    <div class="image-container">
                        <app-file-input [image]="currentModel()?.mapImageSrc" (change)="onFileSelected($event)"
                            (delete)="deleteImage()">
                        </app-file-input>
                    </div>
                </ng-template>
            </ng-container>

            <!-- Mode mask -->
            <ng-container *ngSwitchCase="'mask'">
                <app-mask-editor></app-mask-editor>
            </ng-container>

            <!-- Mode calibration -->
            <ng-container *ngSwitchCase="'calibration'">
                <app-calibration></app-calibration>
            </ng-container>
        </ng-container>
    </div>

    <!-- TOOLBAR -->
    <div class="editor-toolbar">
        <div class="toolbar-title">
            <mat-icon>construction</mat-icon>
            {{"viewer.tools" | translate}}
        </div>

        <div class="allMods">
            <div class="mode">
                <button class="tool-btn" (click)="setMode('transform')" [matTooltip]="'viewer.transform' | translate">
                    <i class="material-icons">transform</i>
                </button>

                <button class="tool-btn" (click)="setMode('calibration')" [class.active]="mode() === 'calibration'"
                    matTooltip="Calibration">
                    <i class="material-icons">straighten</i>
                </button>

                <button class="tool-btn" (click)="setMode('mask')" [class.active]="mode() === 'mask'"
                    [matTooltip]="'viewer.mask' | translate">
                    <i class="material-icons">crop_square</i>
                </button>
            </div>

            <div class="mode">
                <button class="tool-btn close row" (click)="deleteImage()" [disabled]="!canDeleteImage()"
                    [matTooltip]="'viewer.delete_image' | translate">
                    <i class="material-icons">delete</i>
                </button>

                <button class="tool-btn close" (click)="cancel()" [matTooltip]="'viewer.close' | translate">
                    <i class="material-icons">exit_to_app</i>
                </button>

                <button class="tool-btn save" (click)="save()" [disabled]="!isDirty()"
                    [matTooltip]="'viewer.save' | translate ">
                    <i class="material-icons">save</i>
                </button>
            </div>
        </div>
    </div>
</div>